export class NSEServiceError extends Error {
    constructor(message, nseResponseCode, httpStatusCode) {
      super(message); // (1)
      this.source = 
      this.nseResponseCode = nseResponseCode; // (2)
      this.httpStatusCode = httpStatusCode;
    }
  }